window.addEventListener( 'load', () => {
  const SEL = {
    inputField: '.wpcf7-form-control.floating-label',
    fieldWrapper: '.wpcf7-form-control-wrap',
    labelElement: 'label',
  };

  // Only process if there are input fields with the floating-label class
  const floatingLabelInputs = document.querySelectorAll( SEL.inputField );

  if ( floatingLabelInputs.length === 0 ) {
    return; // Exit early if no floating label inputs found
  }

  // Process each input field individually
  floatingLabelInputs.forEach( ( input ) => {
    // Check if field has placeholder attribute
    const hasPlaceholder = input.getAttribute( 'placeholder' )?.length > 0;

    // Check if there's a label element associated with this field
    const hasLabel = checkIfFieldHasLabel( input );

    // Only apply floating placeholder if there's a placeholder AND no label
    if ( hasPlaceholder && ! hasLabel ) {
      replacePlaceHolderAttributeWithLabelElement( input );
    } else if ( hasLabel ) {
      // Mark field as having a label so CSS can exclude it
      input.setAttribute( 'data-has-label', 'true' );
    }
  } );

  /**
   * Checks if a form field has an associated label element
   *
   * @param {HTMLElement} field - The input/textarea field to check
   * @return {boolean} True if field has a label, false otherwise
   */
  function checkIfFieldHasLabel( field ) {
    const fieldWrapper = field.closest( SEL.fieldWrapper );

    if ( ! fieldWrapper ) {
      return false;
    }

    // Check for label elements within the same wrapper
    const labels = fieldWrapper.querySelectorAll( SEL.labelElement );

    // Check if any label is associated with this field
    for ( const label of labels ) {
      const forAttribute = label.getAttribute( 'for' );
      const fieldId = field.getAttribute( 'id' );

      // If label has 'for' attribute that matches field ID
      if ( forAttribute && fieldId && forAttribute === fieldId ) {
        return true;
      }

      // If label contains the field (nested structure)
      if ( label.contains( field ) ) {
        return true;
      }
    }

    // Check for label elements that might be siblings or in parent containers
    const fieldName = field.getAttribute( 'name' );
    if ( fieldName ) {
      // Look for labels with matching name in the same form
      const form = field.closest( 'form' );
      if ( form ) {
        const formLabels = form.querySelectorAll( SEL.labelElement );
        for ( const label of formLabels ) {
          const labelContainsInput = label.querySelector( `${ field.tagName.toLowerCase() }[name="${ fieldName }"]` );
          const labelFor = label.getAttribute( 'for' );
          const fieldId = field.getAttribute( 'id' );
          const labelForMatchesFieldId = labelFor && fieldId && labelFor === fieldId;

          if ( labelContainsInput || labelForMatchesFieldId ) {
            return true;
          }
        }
      }
    }

    return false;
  }

  /**
   * Replaces the placeholder attribute of a form input element with a label element
   * that visually represents the placeholder text and is properly associated with the input.
   *
   * This function:
   * - Retrieves the placeholder text from the given input element.
   * - Creates a <label> element with proper attributes and inserts it after the input.
   * - Removes the original placeholder attribute from the input element.
   * - Ensures proper accessibility and form association.
   *
   * @param {HTMLElement} element - The input element whose placeholder will be replaced.
   */
  function replacePlaceHolderAttributeWithLabelElement( element ) {
    // Generate a unique ID for the input if it doesn't have one
    let fieldId = element.getAttribute( 'id' );
    if ( ! fieldId ) {
      fieldId = 'cvle-floating-label-' + Math.random().toString( 36 ).substring( 2, 11 );
      element.setAttribute( 'id', fieldId );
    }

    // Get the placeholder text
    const placeholderText = element.getAttribute( 'placeholder' );

    // Create the label element with proper attributes
    const labelElement = document.createElement( 'label' );
    labelElement.className = 'cvle-floating-placeholder';
    labelElement.setAttribute( 'for', fieldId );
    labelElement.setAttribute( 'aria-label', placeholderText );
    labelElement.textContent = placeholderText;
    // Insert the label after the input
    const fieldWrapper = element.closest( SEL.fieldWrapper );
    createDynamicStyles( fieldWrapper, element );

    fieldWrapper.appendChild( labelElement );

    // Set a space placeholder to maintain form structure and prevent validation issues
    element.setAttribute( 'placeholder', ' ' );
  }

  /**
   * Creates or updates dynamic CSS styles by injecting them into the document head
   *
   * @param {HTMLElement} fieldWrapper - The field wrapper element
   * @param {HTMLElement} element      - The input element to create styles for
   */
  function createDynamicStyles( fieldWrapper, element ) {
    if ( ! fieldWrapper ) {
      return;
    }

    if ( ! element ) {
      return;
    }

    // Skip textarea elements
    if ( element.tagName.toLowerCase() === 'textarea' ) {
      return;
    }

    // Create or reuse a <style> element
    let styleEl = document.getElementById( 'cvle-floating-label-styles-' + element.id );
    if ( ! styleEl ) {
      styleEl = document.createElement( 'style' );
      styleEl.id = 'cvle-floating-label-styles-' + element.id;
      fieldWrapper.insertBefore( styleEl, fieldWrapper.firstChild );
    }

    // Write CSS variable into the style element
    styleEl.textContent = `
        input.wpcf7-form-control.floating-label[id="${ element.id }"]:not([data-has-label]) + .cvle-floating-placeholder {
            top: ${ element.offsetHeight * 0.5 }px;
        }
    `;
  }
} );
